<script>

import { getCompliantText } from './helpers/compliance'
import { COLORS, isDark, parseColor } from './helpers/colors'
import { isBeans, beansSrc } from './helpers/beans'
import { isJohnEagle } from './helpers/john-eagle'
import { isRollsRoyce } from './helpers/rolls-royce'
import { isKiaOfStamford } from './helpers/kia-of-stam-ford'

export default {
  name: 'GoodDeal',
  props: {
    color: {
      type: String,
      default: 'success'
    },
    ddc: {
      type: Boolean,
      default: false
    },
    cta: {
      type: String,
      default: 'good-deal'
    }
  },
  data () {
    return {
      isJohnEagle: isJohnEagle(),
      isRollsRoyce: isRollsRoyce(),
      isKiaOfStamford: isKiaOfStamford()
    }
  },
  computed: {
    parsedColor: ({ color }) => parseColor(color),
    theme: ({ parsedColor }) => ({
      color: parsedColor === COLORS.success || isDark(parsedColor) ? '#FFF' : '#000',
      backgroundColor: parsedColor
    })
  },
  methods: {
    getCTAKey () {
      switch (true) {
        case this.isJohnEagle:
          return 'packages'
        case this.isKiaOfStamford:
          return 'kia-of-stamford'
        default:
          return this.cta
      }
    }
  },
  render (h) {
    const CTA = {
      'good-deal': [
        h('big', 'Is This A Good Deal?'),
        h('small', 'Click here to find out!')
      ],
      packages: [
        h('small', 'Click here to see'),
        h('big', 'Packages on this car!')
      ],
      'kia-of-stamford': [
        h('big', 'Click Here for Vehicle Information')
      ]
    }

    if (isBeans()) {
      return h('a', {
        class: ['btn-img', this.$style['m4w--img']],
        on: {
          click: event => this.$emit('click', event)
        }
      }, [
        h('img', {
          attrs: {
            src: beansSrc
          }
        })
      ])
    }

    if (this.ddc) {
      return h('a', {
        class: [
          'btn btn-block btn-default price-btn btn-sm',
          this.$style['m4w--ddc'],
          this.isRollsRoyce && this.$style['m4w--ddc--rolls-royce']
        ],
        on: {
          click: event => this.$emit('click', event)
        }
      }, getCompliantText() || CTA[this.getCTAKey()])
    }

    return h('button', {
      class: [this.$style.m4w, ...(this.$attrs.class || [])],
      on: {
        click: event => this.$emit('click', event)
      },
      style: this.theme
    }, CTA[this.cta])
  }
}
</script>

<style lang="scss" module>
.m4w {
  align-items: center;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  display: flex !important;
  flex-direction: column;
  font-family: system-ui;
  font-size: 14px;
  margin-left: auto !important;
  margin-right: auto !important;
  padding: 8px 16px;
  position: relative;

  big {
    font-size: 16px;
    font-weight: 700;
  }

  &::before {
    background-color: currentcolor;
    border-radius: inherit;
    bottom: 0;
    content: "";
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  }

  &:hover::before {
    opacity: 0.08;
  }
}

.m4w,
.m4w--ddc {
  small {
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 17px;
    text-transform: capitalize;
  }
}

.m4w--ddc {
  display: flex !important;
  flex-direction: column;
}

.m4w--ddc--rolls-royce {
  big {
    font-size: 16px;
  }

  big,
  small {
    text-transform: uppercase;
  }
}

.m4w--img {
  cursor: pointer;
}
</style>
